import { render, staticRenderFns } from "./receive_mail.vue?vue&type=template&id=fdb9d1f0&scoped=true&"
import script from "./receive_mail.vue?vue&type=script&lang=js&"
export * from "./receive_mail.vue?vue&type=script&lang=js&"
import style0 from "./receive_mail.vue?vue&type=style&index=0&id=fdb9d1f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb9d1f0",
  null
  
)

export default component.exports